import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import TopBar from '../topbar/topbar'
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import cachios from 'cachios'
import pr from '../assets/pr.jpg'
import Loader from 'react-loader'
import { List } from 'react-content-loader'

class FacultyWiki extends Component {
  constructor(props) {
    super(props);
    console.log(props, 'props')
    this.state = {

      people: '',
      bioimg: '',
      pub: '',
      types: '',
      link: [],
      articletype: '',
      booktype: '',
      chaptype: '',
      conftype: '',
      thesistype: ''
    }
  }

  setlink(id, i) {

    let array = this.state.link
    if (id !== '')
      cachios.get(BASE + 'jsonapi/node/submit_for_work?filter[titleFilter][condition][path]=id&filter[titleFilter][condition][value]=' + id, {
        ttl: 500 /* seconds */,
      })
        .then((data) => {
          console.log(data, 'chk1')
          array[i] = data.data.data[0]
          this.setState({
            link: array
          })
          console.log(array, 'now')

        })
    else {
      array.push('')
      this.setState({
        link: array
      })
      console.log(array, 'now')

    }
  }

  worktypes() {
    cachios.get(BASE + '/jsonapi/taxonomy_term/submit_for_work_types', {
      ttl: 500 /* seconds */,
    })
      .then((data) => {
        console.log(data.data.data, 'chk')
        data.data.data.map((value, ind) => {
          if (value.attributes.name === 'Articles') {
            this.setState({
              articletype: value.id
            })
          }
          else if (value.attributes.name === 'Books') {
            this.setState({
              booktype: value.id
            })
          }
          else if (value.attributes.name === 'Book Chapters') {
            this.setState({
              chaptype: value.id
            })
          }
          else if (value.attributes.name === 'Thesis') {
            this.setState({
              thesistype: value.id
            })
          }
          else if (value.attributes.name === 'Conferences') {
            this.setState({
              conftype: value.id
            })
          }
        })
      })
    console.log(this.state.articletype, this.state.booktype, this.state.chaptype, this.state.thesistype, this.state.conftype, 'chk')
  }
  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    // window.location.href = '/'

  }


  refreshexp() {
    let s = new Date();
    s.setSeconds(s.getSeconds() + 1800);
    localStorage.setItem('expiryref', s)
  }


  checkexpiry() {
    if (localStorage.getItem('expiryref')) {
      let expref = Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if (s > expref) {
        this.signout()
      }
      else {
        this.refreshexp()
      }

    }
    else {
      this.signout()
    }
  }

  componentWillReceiveProps(nextProps) {

    console.log(nextProps.match.params.id, "nextProps")
    if (nextProps.match.params.id !== this.props.match.params.id) {
      this.setState({
        people: '',
        bioimg: ''
      })

      let url = window.location.href;
      let url_string = url;
      let urlStr = new URL(url_string);
      let c = urlStr.searchParams.get("key");
      let nid = urlStr.searchParams.get("nid");

      this.topFunction()
      this.worktypes()
      //API call

      // field publiction & field link
      cachios.get(BASE + 'jsonapi/node/faculty?include=field_selected_publication&filter[drupal_internal__nid]=' + nid, {
        ttl: 500 /* seconds */,
      })
        .then((data) => {
          let i, j, k;
          console.log(data.data.included, 'noww')
          if (data.data.included) {
            this.setState({
              pub: data.data.included
            })
            let array = []
            for (i = 0; i < data.data.included.length; i++) {
              array.push('')
              this.setState({
                link: array
              })
              if (data.data.included[i].relationships.field_reference.data != null) {
                this.setlink(data.data.included[i].relationships.field_reference.data.id, i)
                console.log(this.state.link, 'now')
              }
              else {
                array[i] = '';
                this.setState({
                  link: array
                })

              }

              // else{
              //   let array=this.state.link
              //   array.push('')
              //   this.setState({
              //     link:array
              //   })
              //   console.log(array,'now')

              // }
            }
          }
          cachios.get(BASE + 'jsonapi/node/faculty?include=field_image&filter[drupal_internal__nid]=' + nid, {
            ttl: 500 /* seconds */,
          })
            .then((data) => {
              console.log(data.data.data, 'xxx')
              if (data.data.data.length === 0) {
                window.location.href = '/404'
              }
              this.setState({
                people: data.data.data[0].attributes,
                bioimg: data.data.included ? BASE + data.data.included[0].attributes.uri.url : pr
              })

            })


        })
    }
  }


  setupBeforeUnloadListener = () => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return this.doSomethingBeforeUnload();
    });
  };

  doSomethingBeforeUnload = () => {
    localStorage.removeItem('related_faculty')
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.doSomethingBeforeUnload);
  }

  componentWillMount() {
    this.setupBeforeUnloadListener();

    if (localStorage.getItem('token'))
      this.checkexpiry()
    let related_faculty
    if (localStorage.getItem('related_faculty')) {
      related_faculty = localStorage.getItem('related_faculty')
      let related_faculty_head = localStorage.getItem('related_faculty_head')
      this.setState({
        related_faculty: JSON.parse(related_faculty),
        related_faculty_head: related_faculty_head
      })

    }
    let url = window.location.href;
    let url_string = url;
    let urlStr = new URL(url_string);
    let c = urlStr.searchParams.get("key");
    let nid = urlStr.searchParams.get("nid");

    this.topFunction()
    this.worktypes()
    //API call

    // field publiction & field link
    cachios.get(BASE + 'jsonapi/node/faculty?include=field_selected_publication&filter[drupal_internal__nid]=' + nid, {
      ttl: 500 /* seconds */,
    })
      .then((data) => {
        let i, j, k;
        console.log(data.data.included, 'noww')
        if (data.data.included) {
          this.setState({
            pub: data.data.included
          })
          let array = []
          for (i = 0; i < data.data.included.length; i++) {
            array.push('')
            this.setState({
              link: array
            })
            if (data.data.included[i].relationships.field_reference.data != null) {
              this.setlink(data.data.included[i].relationships.field_reference.data.id, i)
              console.log(this.state.link, 'now')
            }
            else {
              array[i] = '';
              this.setState({
                link: array
              })

            }

            // else{
            //   let array=this.state.link
            //   array.push('')
            //   this.setState({
            //     link:array
            //   })
            //   console.log(array,'now')

            // }
          }
        }
        cachios.get(BASE + 'jsonapi/node/faculty?include=field_image&filter[drupal_internal__nid]=' + nid, {
          ttl: 500 /* seconds */,
        })
          .then((data) => {
            console.log(data.data.data, 'xxx')
            if (data.data.data.length === 0) {
              window.location.href = '/404'
            }
            this.setState({
              people: data.data.data[0].attributes,
              bioimg: data.data.included ? BASE + data.data.included[0].attributes.uri.url : pr
            })
            console.log('related_faculty', data.data.data[0].attributes.drupal_internal__nid)

            // console.log('related_faculty', Number(JSON.parse(related_faculty)[2].nid[0]))

        

          })


      })
  }
  goto(id, nid) {
    if (id === this.state.thesistype) {

      return '/theses_desc/' + nid
    }
    else if (id === this.state.booktype) {

      return '/book_desc/' + nid
    }
    else if (id === this.state.conftype) {

      return '/conf_desc/' + nid
    }
    else if (id === this.state.chaptype) {

      return '/book_chap_desc/' + nid
    }
    else if (id === this.state.articletype) {

      return '/article_desc/' + nid
    }

  }



  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  render() {
    console.log(this.state.articletype, this.state.booktype, this.state.chaptype, this.state.thesistype, this.state.conftype, 'chk')
    console.log(this.state.link, 'nowww')
    let url = window.location.href;
    let url_string = url;
    let urlStr = new URL(url_string);
    let c = urlStr.searchParams.get("key");
    let nid = urlStr.searchParams.get("nid");
    return (
      <div className='peoplewiki'>
        <Header />
        <body className="wiki" >
          <div className='top-contents container' style={{ paddingBottom: '2%' }}>
            <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/research/faculty'>CIS Faculty</Link> / {this.state.people?this.state.people.title.charAt(0).toUpperCase() + this.state.people.title.slice(1):""}</div>
            {/* <TopBar data={'data1'} /> */}
          </div>
          <div className="main-content" style={{ paddingBottom: '4%' }}>
            <div className="container">
              <div className="row">
                <div className="node-wiki node">
                  {this.state.bioimg ? <div className="group-left">
                    <div className="field-name-field-thumbnail">
                      <img src={this.state.bioimg} alt="CIS" />
                      {this.state.related_faculty && this.state.people ?
                        this.state.related_faculty.length > 1 ?
                          <div className="related-fac">
                            <div>
                              <h4>{this.state.related_faculty_head}</h4>
                              {this.state.related_faculty.map((related, ind) => {
                                return (
                                  <div className="rel_fac_link">
                                    <Link className={Number(related.nid[0])=== this.state.people.drupal_internal__nid ? "current" : ""} to={'/faculty/' + `${related.title[0].replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${related.nid}`}>{related.title}</Link>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                          : '' : ''}
                    </div>
                  </div> : <Loader color="#165e84" loaded={false} className="spinner" />}
                  {this.state.people ? <div className="group-middle">
                    <div className="field-name-title">
                      <div className='booktitle_rea'>{this.state.people.title.charAt(0).toUpperCase() + this.state.people.title.slice(1)}</div>
                    </div>

                    <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                      <div className="field-items">
                        <div className="field-item even" property="content:encoded">
                          {this.state.people.body ? ReactHtmlParser(this.state.people.body.processed) : ''}

                        </div>
                      </div>
                    </div>
                    {/* faculty publication */}


                    {this.state.pub && this.state.link.length === this.state.pub.length ? this.state.pub.map((people, index) => {
                      return (
                        <div className='cis_pub field-name-body' style={{ minHeight: 0 }}>
                          <h2 style={{ display: index === 0 && people.attributes.field_title ? '' : 'none' }}>Publications</h2>
                          {people.attributes.field_link === null && this.state.link[index] === '' ?
                            <p>{people.attributes.field_title}</p> :
                            // <Link className='facpublink' to={this.state.link[index]!==''?this.goto(this.state.link[index].relationships.field_select_work_to_submit.data.id,this.state.link[index].attributes.drupal_internal__nid):people.attributes.field_link.uri}>
                            // {people.attributes.field_title}</Link>
                            <a className='facpublink' href={this.state.link[index] !== '' ? this.goto(this.state.link[index].relationships.field_select_work_to_submit.data.id, this.state.link[index].attributes.drupal_internal__nid) : people.attributes.field_link.uri}>
                              {people.attributes.field_title}</a>
                          }
                          {/* {this.state.link[index]!==''?this.goto(this.state.link[index].relationships.field_select_work_to_submit.data.id,this.state.link[index].attributes.drupal_internal__nid):''} */}
                          {/* {people.attributes.field_link?<a target="_blank" style={{textDecoration:'underline'}} className='facpublink' href={people.attributes.field_link.uri}>{people.attributes.field_link.uri}</a>:''} */}

                        </div>
                      )
                    }) : ''}


                  </div> : ''}

                </div>
              </div>
            </div>
          </div>



        </body>


        <div><Footer /></div>
      </div>
    )
  }
}


export default FacultyWiki;
